"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseListSheetModal = CaseListSheetModal;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const ToolsFetch_1 = __importDefault(require("../../React/Tools/ToolsFetch"));
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
/**
 * Okno generowania „Spisu spraw" — arkusza Google z drzewem kamieni, spraw i zadań.
 *
 * Nazwa pliku koduje konfigurację (statusy + osoby): to samo ustawienie nadpisuje swój
 * arkusz, inne tworzy nowy obok. Dlatego okno nie pyta o nazwę ani o miejsce zapisu.
 */
function CaseListSheetModal({ show, onHide, scope, }) {
    const [includeFinished, setIncludeFinished] = (0, react_1.useState)(false);
    const [personScope, setPersonScope] = (0, react_1.useState)("all");
    const [selectedPersonIds, setSelectedPersonIds] = (0, react_1.useState)([]);
    const [busy, setBusy] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [result, setResult] = (0, react_1.useState)(null);
    const [folderUrl, setFolderUrl] = (0, react_1.useState)(null);
    const self = MainSetupReact_1.default.getCurrentUserAsPerson();
    const selfHasTasks = !!self && scope.taskOwners.some((p) => p.id === self.id);
    // Oba okna mogą wisieć w drzewie jednocześnie — prefiks trzyma id pól unikalne.
    const idPrefix = scope.action;
    /**
     * Adres podfolderu „Spisy spraw" na Dysku — dociągany przy otwarciu okna, bo klient
     * zna tylko folder kontraktu/projektu, a podfolder zakłada serwer przy generowaniu.
     *
     * Cichy błąd jest tu w porządku: link to udogodnienie, a nie warunek wygenerowania
     * spisu — czerwony alert nad formularzem sugerowałby, że coś jest zepsute.
     *
     * scope.target celowo poza zależnościami: to literał tworzony na nowo przy każdym
     * renderze rodzica, więc pętliłby efekt. scope.action wystarczy za tożsamość zakresu.
     */
    (0, react_1.useEffect)(() => {
        if (!show)
            return;
        let cancelled = false;
        (async () => {
            try {
                const found = await ToolsFetch_1.default.fetchJsonWithSafeError(MainSetupReact_1.default.serverUrl + "caseListSheetFolder", {
                    method: "POST",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(scope.target),
                });
                if (!cancelled)
                    setFolderUrl(found?.url ?? null);
            }
            catch {
                if (!cancelled)
                    setFolderUrl(null);
            }
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, scope.action]);
    function resolvePersonIds() {
        if (personScope === "me")
            return self ? [self.id] : [];
        if (personScope === "selected")
            return selectedPersonIds;
        return [];
    }
    function togglePerson(personId) {
        changeConfig(() => setSelectedPersonIds((prev) => prev.includes(personId) ? prev.filter((id) => id !== personId) : [...prev, personId]));
    }
    /** Każda zmiana ustawień unieważnia wynik — inaczej pod nowymi opcjami wisiałby
     *  link do arkusza wygenerowanego dla poprzedniej konfiguracji. */
    function changeConfig(apply) {
        setResult(null);
        apply();
    }
    async function handleGenerate() {
        setBusy(true);
        setError(null);
        setResult(null);
        try {
            // bez retry: endpoint tworzy/nadpisuje plik na Drive — ponowienie po utracie
            // odpowiedzi zdublowałoby pracę na tym samym arkuszu
            const generated = await ToolsFetch_1.default.fetchJsonWithSafeError(MainSetupReact_1.default.serverUrl + scope.action, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...scope.target,
                    includeFinished,
                    personIds: resolvePersonIds(),
                }),
            });
            setResult(generated);
            // przy pierwszym spisie podfolder powstał dopiero co — stąd link bierze się
            // z odpowiedzi, a nie z ponownego odpytywania Dysku
            if (generated?.folderUrl)
                setFolderUrl(generated.folderUrl);
            if (generated?.url)
                window.open(generated.url, "_blank");
        }
        catch (e) {
            setError(e instanceof Error ? e.message : "Wystąpił błąd");
        }
        finally {
            setBusy(false);
        }
    }
    const canGenerate = !busy && (personScope !== "selected" || selectedPersonIds.length > 0);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: onHide, size: "lg", centered: true, enforceFocus: false },
        react_1.default.createElement("div", { onClick: (e) => e.stopPropagation(), onDoubleClick: (e) => e.stopPropagation() },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement("div", { className: "me-2" },
                    react_1.default.createElement("div", { className: "d-flex align-items-center mb-1" },
                        react_1.default.createElement("h5", { className: "mb-0" }, "Spis spraw"),
                        folderUrl && (react_1.default.createElement("span", { className: "ms-2", title: "Otw\u00F3rz folder \u201ESpisy spraw\u201D na Dysku Google" },
                            react_1.default.createElement(CommonComponents_1.GDFolderIconLink, { layout: "horizontal", folderUrl: folderUrl })))),
                    react_1.default.createElement("div", { className: "text-secondary small" }, scope.subtitle))),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", onClose: () => setError(null), dismissible: true }, error)),
                react_1.default.createElement("div", { className: "p-3 mb-3 bg-light border rounded" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "fw-bold" }, "Statusy"),
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", id: `${idPrefix}StatusesActive`, name: `${idPrefix}Statuses`, label: "Bez zako\u0144czonych i archiwalnych", checked: !includeFinished, disabled: busy, onChange: () => changeConfig(() => setIncludeFinished(false)) }),
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", id: `${idPrefix}StatusesAll`, name: `${idPrefix}Statuses`, label: "Wszystkie statusy", checked: includeFinished, disabled: busy, onChange: () => changeConfig(() => setIncludeFinished(true)) }),
                    react_1.default.createElement("div", { className: "text-secondary small mt-1" }, "Wariant bez zako\u0144czonych pomija zamkni\u0119te sprawy, zrobione zadania i zako\u0144czone kamienie. Zadania z Backlogu zostaj\u0105.")),
                react_1.default.createElement("div", { className: "p-3 bg-light border rounded" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "fw-bold" }, "Zadania"),
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", id: `${idPrefix}PersonsAll`, name: `${idPrefix}Persons`, label: scope.allPersonsLabel, checked: personScope === "all", disabled: busy, onChange: () => changeConfig(() => setPersonScope("all")) }),
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", id: `${idPrefix}PersonsMe`, name: `${idPrefix}Persons`, label: "Tylko moje", checked: personScope === "me", disabled: busy || !self, onChange: () => changeConfig(() => setPersonScope("me")) }),
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", id: `${idPrefix}PersonsSelected`, name: `${idPrefix}Persons`, label: "Wskazanych os\u00F3b", checked: personScope === "selected", disabled: busy || scope.taskOwners.length === 0, onChange: () => changeConfig(() => setPersonScope("selected")) }),
                    personScope === "selected" && (react_1.default.createElement("div", { className: "mt-2 ps-3" }, scope.taskOwners.map((person) => (react_1.default.createElement(react_bootstrap_1.Form.Check, { key: person.id, type: "checkbox", id: `${idPrefix}Person${person.id}`, label: `${person.name} ${person.surname}`, checked: selectedPersonIds.includes(person.id), disabled: busy, onChange: () => togglePerson(person.id) }))))),
                    personScope === "me" && !selfHasTasks && (react_1.default.createElement("div", { className: "text-warning small mt-1" }, scope.noSelfTasksNote)),
                    scope.taskOwners.length === 0 && (react_1.default.createElement("div", { className: "text-secondary small mt-1" }, scope.noOwnersNote)),
                    react_1.default.createElement("div", { className: "text-secondary small mt-1" }, "Zadania nieprzypisane pokazujemy zawsze. Przy kilku osobach dochodzi kolumna \u201EOsoba\"; przy jednej osoba trafia do nazwy arkusza.")),
                result && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", className: "mt-3 mb-0" },
                    react_1.default.createElement("a", { href: result.url, target: "_blank", rel: "noopener noreferrer", title: "Otw\u00F3rz spis spraw", className: "link-body-emphasis link-underline-opacity-25 link-underline-opacity-100-hover" }, `${result.overwritten ? "Zaktualizowano arkusz" : "Utworzono arkusz"}: ${result.name}`)))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", disabled: busy, onClick: onHide }, "Zamknij"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", disabled: !canGenerate, onClick: handleGenerate },
                    busy ? (react_1.default.createElement(react_bootstrap_1.Spinner, { as: "span", animation: "border", size: "sm", role: "status", className: "me-2" })) : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faListCheck, className: "me-2" })),
                    "Generuj")))));
}
